import { merge } from 'lodash';

const defaultArgs = {};

const defaultAttrs = {
  flakeAmount: true,
  index: true,
  id: true,
  timestamp: true,
  user: true,
  veFlakeAmount: true
};

export default (args = {}, attrs = {}) => ({
  userLeaveRequests: {
    __args: merge({}, defaultArgs, args),
    ...merge({}, defaultAttrs, attrs)
  }
});
